import { put, select } from "typed-redux-saga";
import { rootActions } from "../reducers/root.slice";
import { setStatus } from "../dom-utils";
import RowUtils from "../utils/RowUtils";
import MathUtils from "../utils/MathUtils";
import { selectRootState } from "../selectors";

function* convertToContinuous(
  action: ReturnType<typeof rootActions.convertToContinuous>
) {
  const { rows, leftPanel, continuousColumns, categoricalColumns, rightPanel } =
    yield* select(selectRootState);

  const categories = action.payload;
  const { selectedColumn } = leftPanel;
  const { categoricalColumnsAsContinuous } = rightPanel;

  if (!selectedColumn) {
    throw new Error("No column selected");
  }

  setStatus(`Converting column ${selectedColumn} to continuous`);

  const newRows = rows.map((row) => {
    const oldValue = RowUtils.getValue(row, selectedColumn);
    if (!oldValue) {
      return row;
    }

    return {
      ...row,
      [selectedColumn]: String(categories.indexOf(oldValue)),
    };
  });

  const newContinuousColumns = [...continuousColumns, selectedColumn];

  const computedValues = MathUtils.findStandardDeviations(
    newRows,
    newContinuousColumns
  );

  yield* put(
    rootActions.convertToContinuousDone({
      rows: newRows,
      continuousColumns: newContinuousColumns,
      categoricalColumns: categoricalColumns.filter(
        (c) => c !== selectedColumn
      ),
      categoricalColumnsAsContinuous: {
        ...categoricalColumnsAsContinuous,
        [selectedColumn]: categories,
      },
      computedValues,
    })
  );

  yield* put(rootActions.generateGraph());
}

export default convertToContinuous;
